const BoltIcom = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M3.19922 8.00156L3.91172 2.30156C3.96172 1.90156 4.30172 1.60156 4.70672 1.60156H8.92172C9.29672 1.60156 9.59922 1.90406 9.59922 2.27906C9.59922 2.35906 9.58422 2.44156 9.55672 2.51656L8.39922 5.60156H11.8817C12.3867 5.60156 12.7992 6.01156 12.7992 6.51906C12.7992 6.70406 12.7442 6.88406 12.6392 7.03656L7.83422 14.0616C7.68672 14.2766 7.44422 14.4041 7.18672 14.4041H7.11422C6.72172 14.4041 6.40172 14.0841 6.40172 13.6916C6.40172 13.6341 6.40922 13.5766 6.42422 13.5191L7.59922 8.80156H3.99922C3.55672 8.80156 3.19922 8.44406 3.19922 8.00156Z"
      fill="white"
    />
  </svg>
);

export default BoltIcom;
